// Base configuration for the API
export const API_BASE_URL =  'https://api.kaafipay.so';
const API_KEY =  '7511cf53c3dbe0745edd6d4ebebcd97deaed6f02a5ab99e0ad05d6f21b907de9e17f3e42de9ca7b61130f8aac72bb167';

/**
 * Generic request helper with API key and error handling
 */
async function request(endpoint, options = {}) {
  const { headers, params, ...customConfig } = options;

  // Build query string if URL parameters are passed
  let url = `${API_BASE_URL}/api/sys/${endpoint}`;
  if (params) {
    const searchParams = new URLSearchParams(params);
    url += `?${searchParams.toString()}`;
  }

  // Set default headers including API key authorization
  const defaultHeaders = {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY, // Or 'Authorization': `Bearer ${API_KEY}` depending on backend
  };

  const config = {
    method: options.method || 'GET',
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    ...customConfig,
  };

  try {
    const response = await fetch(url, config);

    // Handle non-2xx HTTP response statuses
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.message || `HTTP Error \({response.status}:\){response.statusText}`;
      throw new Error(errorMessage);
    }

    // Handle empty responses (e.g., 204 No Content)
    if (response.status === 204) {
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error(`API Request Failed: [\({config.method}]\){url}`, error.message);
    throw error;
  }
}

// Exported service API
export const apiService = {
  get: (endpoint, params = {}, options = {}) => 
    request(endpoint, { method: 'GET', params, ...options }),

  post: (endpoint, body, options = {}) => 
    request(endpoint, { method: 'POST', body: JSON.stringify(body), ...options }),

  put: (endpoint, body, options = {}) => 
    request(endpoint, { method: 'PUT', body: JSON.stringify(body), ...options }),

  delete: (endpoint, options = {}) => 
    request(endpoint, { method: 'DELETE', ...options }),
};